import { httpsCallable } from 'firebase/functions'
import { functions } from '@/firebase'
import { useAuthStore } from '@/store/authstore'

type CreatePortalPayload = { customerId: string; returnUrl?: string }

export async function openStripePortal(customerId?: string, returnUrl?: string) {
    const authStore = useAuthStore()
    const cid = customerId || authStore.user?.stripeCustomerId

    // If we don't have a customer yet, send the user to a Payment Link (first-time payment)
    if (!cid) {
        const paymentLink = import.meta.env.VITE_STRIPE_PAYMENT_LINK as string | undefined
        const portalLogin = import.meta.env.VITE_STRIPE_PORTAL_URL as string | undefined
        if (paymentLink && paymentLink.length > 0) {
            const email = authStore.user?.email
            if (email) {
                try {
                    const u = new URL(paymentLink)
                    u.searchParams.set('prefilled_email', email)
                    window.location.href = u.toString()
                    return
                } catch {
                    const sep = paymentLink.includes('?') ? '&' : '?'
                    const params = new URLSearchParams({ prefilled_email: email })
                    window.location.href = `${paymentLink}${sep}${params.toString()}`
                    return
                }
            }
            window.location.href = paymentLink
            return
        }
        if (portalLogin && portalLogin.length > 0) {
            window.location.href = portalLogin
            return
        }
        throw new Error('No Stripe customerId and no fallback links configured. Set VITE_STRIPE_PAYMENT_LINK or VITE_STRIPE_PORTAL_URL.')
    }

    // Known customer -> open a Customer Portal session via callable
    const callable = httpsCallable<any, { url: string }>(functions, 'create_portal_session')
    const res = await callable({ customerId: cid, returnUrl: returnUrl || `${window.location.origin}/home` } as CreatePortalPayload)
    const url = res.data?.url
    if (!url) throw new Error('No portal URL returned')
    window.location.href = url
}
